'use strict';var _dec,_desc,_value,_class;function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key]});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=!0}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=void 0}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null}return desc}

const _=require('pulsar-utils/dist-es6/_');
const BaseController=require('../../../../../dist-es6/client/angularCommon/baseController');
const SocketResponse=require('../../../../../dist-es6/client/dtos/socketResponse');
const UserInfo=require('../../../../../dist-es6/client/dtos/userInfo');
const HandleUncaughtErrors=require('../../../../../dist-es6/client/services/uncaughtErrorHandler').Annotations.HandleUncaughtErrors;
const ModalSubmissionResult=require('../../../../../dist-es6/client/angularCommon/modalSubmissionResult');let

DeleteUserModalController=(_dec=




















HandleUncaughtErrors(ModalSubmissionResult.FromError),(_class=class DeleteUserModalController extends BaseController{static get $inject(){return['$modalInstance','uncaughtErrorHandler','user','onUserDeleted','socketService','uiCommandFactory','notificationService']}constructor($modalInstance,uncaughtErrorHandler,user,onUserDeleted,socketService,uiCommandFactory,notificationService){_.ensureInstanceOf(UserInfo,user);super(uncaughtErrorHandler);this._$modalInstance=$modalInstance;this._user=user;this._onUserDeleted=onUserDeleted;this._socketService=socketService;this._notificationService=notificationService;this._deleteUserCommand=uiCommandFactory.makeForModal($modalInstance,this._deleteUser.bind(this))}get deleteUserCommand(){return this._deleteUserCommand}
async _deleteUser(){
let deleteResult=await this._socketService.sendAndWaitForResponse('DeleteUser',{id:this._user.id.toString()});

if(!SocketResponse.succeeded(deleteResult)){
let message='There was an error deleting the user.';

if(deleteResult.status==='CannotDeleteSelf'){
message='You cannot delete yourself.';
}

if(deleteResult.status==='HttpError'){
if(deleteResult.body.httpStatus===403){
message='You cannot delete the primary user.';
}else if(deleteResult.body.httpStatus===404){
message='The user was not found, could not delete user.';
}
}

this._notificationService.displayNotification(message,'error');

return ModalSubmissionResult.Close();
}

this._notificationService.displayNotification('User successfully deleted.','success');

await this._onUserDeleted();

return ModalSubmissionResult.Close();
}

get user(){
return this._user;
}

onCancel(){
this._$modalInstance.dismiss();
}},(_applyDecoratedDescriptor(_class.prototype,'_deleteUser',[_dec],Object.getOwnPropertyDescriptor(_class.prototype,'_deleteUser'),_class.prototype)),_class));


module.exports=DeleteUserModalController;
//# sourceMappingURL=deleteUserModalController.js.map
